/** Need and service categories. The matching spec describes 15 rule-based categories plus a general fallback. */
export const CATEGORIES = [
  "Home and Repairs",
  "Legal",
  "Finance and Accounting",
  "Marketing and Growth",
  "Design and Creative",
  "Software and IT",
  "Health and Wellness",
  "Education and Coaching",
  "Real Estate",
  "Events and Hospitality",
  "Writing and Media",
  "Hiring and Recruiting",
  "Fundraising and Investment",
  "Sales and Partnerships",
  "Travel and Relocation",
  "General Services",
] as const;

export type Category = (typeof CATEGORIES)[number];
export const DEFAULT_CATEGORY: Category = "General Services";

export const VISIBILITY_OPTIONS: { value: "private" | "connections" | "network"; label: string; hint: string }[] = [
  { value: "private", label: "Private", hint: "Only you. Not used for matching." },
  { value: "connections", label: "My connections", hint: "Matched against people your connections know." },
  { value: "network", label: "Hub network", hint: "Matched across Hub, including people you are not connected to." },
];

export const TIMELINE_SUGGESTIONS = ["As soon as possible", "This month", "This quarter", "This year", "No rush"];

const CATEGORY_HINTS: [Category, RegExp][] = [
  ["Home and Repairs", /\b(plumb|electric|hvac|roof|contractor|renovat|handyman|clean|landscap|paint|floor|carpent)/i],
  ["Legal", /\b(lawyer|attorney|legal|contract|trademark|patent|incorporat|visa|immigration)/i],
  ["Finance and Accounting", /\b(account|bookkeep|tax|cfo|financ|payroll|audit|invoice)/i],
  ["Marketing and Growth", /\b(market|seo|growth|brand|ads?|campaign|social media|content strategy|pr\b)/i],
  ["Design and Creative", /\b(design|ux|ui|logo|illustrat|photograph|video|brand identity|figma)/i],
  ["Software and IT", /\b(software|developer|engineer|app|website|web|it support|devops|cloud|data|api|saas|code)/i],
  ["Health and Wellness", /\b(doctor|therap|coach|fitness|nutrition|mental|wellness|physio|dentist|yoga)/i],
  ["Education and Coaching", /\b(tutor|teach|mentor|course|training|workshop|lesson|coaching)/i],
  ["Real Estate", /\b(real estate|realtor|apartment|house|rent|lease|mortgage|property|office space)/i],
  ["Events and Hospitality", /\b(event|wedding|cater|venue|party|conference|host|dj|photobooth)/i],
  ["Writing and Media", /\b(writ|editor|copy|journalist|podcast|ghostwrit|translat|newsletter)/i],
  ["Hiring and Recruiting", /\b(hire|hiring|recruit|talent|candidate|job|intern|headhunt)/i],
  ["Fundraising and Investment", /\b(invest|fundrais|angel|vc|venture|seed|capital|grant|donor)/i],
  ["Sales and Partnerships", /\b(sales|partnership|distribut|reseller|intro to|customer|lead gen|biz dev)/i],
  ["Travel and Relocation", /\b(travel|relocat|moving|mover|flight|hotel|trip|visa)/i],
];

/** Rule-based category inference over the title and description. */
export function inferCategory(text: string): Category {
  for (const [category, re] of CATEGORY_HINTS) if (re.test(text)) return category;
  return DEFAULT_CATEGORY;
}
